import { handleActions } from 'redux-actions';

import { RESET, SAVE_TEMPLATES_TABLE, SHOW_ALL_TEMPLATES } from './actionTypes';

const initialStoreData = {
	list: [],
	templatesNumberAvailable: null,
	showAllTemplates: false,
};

const reducer = {
	[SAVE_TEMPLATES_TABLE]: (state, action) => ({
		...state,
		list: [...action.payload.data],
		templatesNumberAvailable: action.payload.pageMetaData.totalRows,
	}),
	[RESET]: () => initialStoreData,
	[SHOW_ALL_TEMPLATES]: (state) => ({
		...state,
		showAllTemplates: true,
	}),
};

export default handleActions(reducer, initialStoreData);
